<template>
  <div class="view project-details" v-if="project">
    <section class="project-header">
      <div class="project-info">
        <div class="top-header">
          <!--<div class="title">{{project.name || 'Untitled project'}}</div>-->
          <edit-in-place format="title" v-model="project.name" @input="saveChanges" :placeholder="'Untitled project'"></edit-in-place>
          <div class="right-info">
            <div class="project-date">
              <div class="date-icon"></div>
              Created: {{ project.creationTimestamp | formatDate }}
            </div>
            <project-card-status :status="project.status"></project-card-status>
            <project-action-menu :project="project"></project-action-menu>
          </div>
        </div>
        <!--<div class="desc">{{project.description || 'Project without description'}}</div>-->
        <edit-in-place :isMultiline="true" v-model="project.description" @input="saveChanges" :placeholder="'Add description'"></edit-in-place>
        <div class="expand-toggle" @click="openCollapsibleDescription = !openCollapsibleDescription">{{!openCollapsibleDescription ? "VIEW  FULL DESCRIPTION" : "CLOSE DESCRIPTION"}}</div>
        <div class="collapsible-description" :class="{'open': openCollapsibleDescription}">
          <project-description :project="project"></project-description>
        </div>
      </div>
      <div class="project-numbers">
        <div class="indicator">
          <div class="value">{{numSubjects}}</div><div class="subject-icon"></div> Subjects
        </div>
        <div class="indicator">
          <div class="value">{{numFinishedTrials}}</div><div class="finished-trials-icon"></div> Finished trials
        </div>
        <div class="indicator">
          <div class="value">{{numTokens}}</div><div class="token-icon"></div> Compute tokens
        </div>
        <div class="project-actions">
          <div class="btn btn--primary btn-results" :class="{'disabled': numFinishedTrials == 0}" @click="() => numFinishedTrials > 0 && goToResults()">Project results<!-- {{$t('see_results')}} --></div>
        </div>
      </div>
    </section>
    <section class="trials">
      <div class="section-title">
        <h4>{{$t('trials')}}</h4>
      </div>
      <div class="trial-container">
        <project-trials-list :project="project"></project-trials-list>
      </div>
    </section>
  </div>
  <div class="view error" v-else-if="error">
    {{error}}
  </div>
  <div class="view" v-else>
    <loading-overlay></loading-overlay>
  </div>
</template>

<script>
import Api from '@/api'
import ProjectDescription from '@/components/project/ProjectDescription'
import ProjectTrialsList from '@/components/project/ProjectTrialsList'
import ProjectResults from '@/components/project/ProjectResults'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import EditInPlace from '@/components/commons/EditInPlace'
import ProjectCardStatus from '@/components/project/ProjectCardStatus'
import ProjectActionMenu from '@/components/project/ProjectActionMenu'

export default {
  name: 'ProjectDetailsView',
  components: {ProjectDescription, ProjectTrialsList, ProjectResults, LoadingOverlay, ProjectCardStatus, ProjectActionMenu,EditInPlace},
  data () {
    return {
      // activeTabIndex: 'description'
      openCollapsibleDescription: false
    }
  },
  methods: {
    goToResults () {
      this.$router.push({path: `/project/${this.project.id}/results`})
    },
    saveChanges () {
      this.saving = true
      Api.putProject(this.project).then(resp => {
        this.saving = false
      }).catch(err => {
        console.log(err)
        this.saving = false
      })
    }
  },
  computed: {
    error () {
      return this.$store.state.paramsData.error
    },
    project () {
      return this.$store.state.paramsData.project
    },
    hasTrials () {
      return this.project.trials && this.project.trials.length > 0
    },
    numSubjects () {
      let draftTrials = this.project.trials.filter(trial => trial.status == 'draft')
      let subjectsOfDraftTrials = draftTrials.length == 0 ? 0 : draftTrials.reduce( (sum, trial) => sum + trial.cohortGeneration.numberOfSubjects, 0)
      let otherTrials = this.project.trials.filter(trial => trial.status != 'draft')
      let subjectsOfOtherTrials = otherTrials.length == 0 ? 0 : otherTrials.reduce( (sum, trial) => sum + trial.cohortGeneration.originTemplateIds.length, 0)
      return subjectsOfDraftTrials + subjectsOfOtherTrials
    },
    numFinishedTrials () {
      return this.project.trials.filter(trial => trial.status == 'finished').length
    },
    numTokens () {
      let totalTokenCount = this.project.trials.reduce( ( sum, item ) => sum + item.runConfig.computeTokens , 0)
      return parseFloat(totalTokenCount.toFixed(2))
    }
  }
}
</script>

<style lang="stylus" scoped>
.project-details
  display: flex
  flex-direction: column
  overflow: scroll
  section
    display: block
    padding-top: 20px
    padding-bottom: 20px
    padding-left: 80px
    padding-right: 80px
    +m-breakpoint(sm md)
      padding-left: 20px
      padding-right: 20px
  .project-header
    background $titan-white
    .project-info
      border-bottom 1px solid $mystic
      margin-bottom 20px
      padding-bottom 20px
      .top-header
        display flex
        margin-bottom 10px
        .right-info
          margin-left auto
          display flex
          align-items center
          .project-date
            display flex
            m-font-size(14,18)
            color $river-bed
            align-items center
            margin-right 20px
            +m-breakpoint(sm md)
              display none
          .date-icon
            m-icon("calendar", 25)
      .expand-toggle
        color $cloud-burst
        m-font-size(12,30)
        font-weight $fw-bold
        text-transform uppercase
        cursor: pointer
        margin-top 10px
        &:hover
          text-decoration underline

    .collapsible-description
      max-height: 0
      overflow: hidden
      transition: max-height 0.2s ease-out
      &.open
        max-height: calc(100vh - 320px)
    .project-numbers
      display flex
      align-items center
      flex-wrap wrap
      .indicator
        color $river-bed
        display flex
        m-font-size(14,18)
        margin-right 50px
        align-items flex-end
        .value
          m-font-size(30,30)
          color $cloud-burst
          font-weight $fw-light
          margin-right 8px
        .subject-icon
          m-icon("participants", 12)
          margin-right 6px
          margin-bottom 4px
        .finished-trials-icon
          m-icon("finished", 26)
          background-position center 3px
        .token-icon
          m-icon("token-single", 26)
          background-position center 3px
      .project-actions
        margin-left auto
        margin-top 10px
        display: flex
        flex-direction: row
        +m-breakpoint(sm md)
          display none
        .btn-results
          width 200px
  .section-title
    width 100%
    border-bottom 2px solid $titan-white
    margin-bottom: 10px
    margin-top: 50px
    h4
      margin-bottom 10px
  .trial-container
    margin-bottom 80px

</style>
